import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import PageMeta from '../components/PageMeta';
import api from '../services/api';
import './Blog.css';

const excerpt = (html, maxLen = 160) => {
  const text = html.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
  return text.length <= maxLen ? text : text.slice(0, maxLen) + '…';
};

const formatDate = (dateStr) => {
  if (!dateStr) return '';
  return new Date(dateStr).toLocaleDateString('en-NG', { year: 'numeric', month: 'long', day: 'numeric' });
};

const Blog = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        setLoading(true);
        setError('');
        const response = await api.get('/blogs');
        const data = response.data;
        setBlogs(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error('Failed to fetch blogs', err);
        setError(err.response?.data?.message || 'Failed to load blogs.');
        setBlogs([]);
      } finally {
        setLoading(false);
      }
    };
    fetchBlogs();
  }, []);

  return (
    <Layout>
      <PageMeta
        title="Blog"
        description="FM Ultratech Farms blog – news, tips, and updates on agriculture and our products."
      />
      <div className="blog-page">
        <div className="blog-hero">
          <h1>Blog</h1>
          <p>News, tips, and updates from FM Ultratech Farms</p>
        </div>
        <div className="blog-content">
          <div className="blog-container">
            {loading ? (
              <p className="blog-loading">Loading posts…</p>
            ) : error ? (
              <p className="blog-error">{error}</p>
            ) : blogs.length === 0 ? (
              <p className="blog-empty">No blog posts yet. Check back soon.</p>
            ) : (
              <ul className="blog-list">
                {blogs.map((post) => (
                  <li key={post.id} className="blog-card">
                    <Link to={`/blog/${post.id}`} className="blog-card-link">
                      {post.featured_image_url && (
                        <div className="blog-card-image">
                          <img src={post.featured_image_url} alt="" />
                        </div>
                      )}
                      <div className="blog-card-body">
                        <time className="blog-card-date" dateTime={post.blog_date}>
                          {formatDate(post.blog_date)}
                        </time>
                        <h2 className="blog-card-title">{post.title}</h2>
                        <p className="blog-card-excerpt">{excerpt(post.content)}</p>
                        <span className="blog-card-more">Read more</span>
                      </div>
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Blog;
